<template>
    <div>
        <v-row justify="center">
            <v-dialog v-model="dialog" persistent scrollable max-width="600px">
                <v-card :style="($vuetify.breakpoint.mdAndDown) ? 'width:auto;' : 'min-width:300px;max-width:600px;'">
                    <v-card-title>{{ formTitle }}</v-card-title>

                    <v-divider></v-divider>

                    <v-card-text style="height: auto;">
                        <br>

                        <form-validation-messages :messages="apiValidationMessages"></form-validation-messages>
                        <form-submit-messages :messages="apiMessages" :errorMessages="apiErrorMessages"></form-submit-messages>

                        <v-form id="form_edit_maintenance" ref="form" v-model="valid" lazy-validation>

                            <v-text-field
                                v-model="maintenance_timestamp"
                                label="Service completed at"
                                append-icon="mdi-calendar-today"
                                filled
                                :rules="service_completed_at_rules"
                            ></v-text-field>

                            <v-text-field
                                v-model="device_name"
                                label="Business premise"
                                append-icon="mdi-map-marker"
                                readonly
                                filled
                            ></v-text-field>

                            <v-text-field v-if="last_maintenance !== null"
                                v-model="last_maintenance"
                                label="Last maintenance"
                                append-icon="mdi-wrench"
                                readonly
                                filled
                            ></v-text-field> 

                            <v-text-field
                                v-model="servicemen"
                                label="Servicemen"
                                append-icon="mdi-account-box"
                                readonly
                                filled
                            ></v-text-field>

                            <v-textarea
                                outlined
                                name="note"
                                label="Notes"
                                v-model="note"
                                counter
                                :rules="[]"
                                clearable
                                rows="10"
                            ></v-textarea>

                        </v-form>
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-text id="form--card--actions--mobile" v-if="$vuetify.breakpoint.xsOnly">
                        <v-btn
                            block
                            outlined
                            style="margin-bottom:15px;"
                            @click="submitForm()"
                            color="success"
                            :disabled="disableSubmit"
                            :loading="loading"
                        >
                            <v-icon left>mdi-arrow-right</v-icon>{{ submitText }}
                        </v-btn>

                        <v-btn
                            block
                            outlined
                            @click="cancel()"
                            color="error"
                            :disabled="loading"
                        >
                            <v-icon left>mdi-close</v-icon>{{ cancelText }}
                        </v-btn>
                    </v-card-text>

                    <v-card-text id="form--card--actions--desktop" v-else>
                        <v-btn
                            @click="submitForm()"
                            color="success"
                            text
                            :disabled="disableSubmit"
                            :loading="loading"
                        >
                            <v-icon left>mdi-arrow-right</v-icon>{{ submitText }}
                        </v-btn>

                        <v-btn
                            @click="cancel()"
                            color="error"
                            text
                            :disabled="loading"
                        >
                            <v-icon left>mdi-close</v-icon>{{ cancelText }}
                        </v-btn>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </v-row>
    </div>
</template>

<script>
import { EventBus } from '@/main.js'
import moment from 'moment'

const FormValidationMessages = () => import('@/components/FormValidationMessages.vue')
const FormSubmitMessages = () => import('@/components/FormSubmitMessages.vue')

export default {
    name: 'edit-maintenance-dialog',

    components: {
        FormValidationMessages,
        FormSubmitMessages
    },

    data: () => ({
        valid: false,
        dialog: false,
        loading: false,
        item: {},
        disableSubmit: false,

        note: null,
        servicemen: null,
        device_name: null,
        last_maintenance: null,
        last_maintenance_entrances: null,
        maintenance_timestamp: null,

        business_premise_id: null,
        business_premise_uuid: null,
        organization_id: null,
        maintenance_schedule_group_id: null,
        maintenance_schedule_group_uuid: null,

        formTitle: 'Edit maintenance record',
        submitText: 'Save',
        cancelText: 'Cancel',

        backendMessages: [],
        backendErrorMessages: [],
        backendValidationMessages: [],

        service_completed_at_rules: [
            v => !!v || 'Service completed at is required',
            v => moment(v, 'DD.MM.YYYY HH:mm:ss', true).isValid() || 'Format must be DD.MM.YYYY HH:mm:ss'
        ]
    }),

    computed: {
        apiMessages() {
            return this.backendMessages
        },

        apiErrorMessages() {
            return this.backendErrorMessages
        },

        apiValidationMessages() {
            return this.backendValidationMessages
        }
    },

    methods: {
        submitForm() {
            let vm = this

            if (this.$refs.form.validate()) {
                vm.cancelText = 'Cancel'
                vm.loading = true
                vm.backendValidationMessages = []
                vm.backendMessages = []
                vm.backendErrorMessages = []

                let payload = {
                    business_premise_id: vm.business_premise_id,
                    business_premise_uuid: vm.business_premise_uuid,
                    organization_id: vm.organization_id,
                    maintenance_schedule_group_id: vm.maintenance_schedule_group_id,
                    maintenance_schedule_group_uuid: vm.maintenance_schedule_group_uuid,
                    uuid: vm.maintenance_schedule_group_uuid,
                    note: vm.note,
                    maintenance_timestamp: vm.maintenance_timestamp
                }

                vm.$store.dispatch('UPDATE_MAINTENANCE', payload)
                    .then(response => {
                        vm.backendMessages.push('Maintenance record has been successfully updated.')
                        vm.disableSubmit = true
                        vm.cancelText = 'Close'
                    })
                    .catch(error => {
                        console.log('UPDATE MAINTENANCE error')
                        console.log(error)

                        if (error.response && error.response.status === 422) {
                            for (const property in error.response.data.errors) {
                                let propertyData = error.response.data.errors[property]

                                propertyData.forEach(message => {
                                    vm.backendValidationMessages.push(message)
                                })
                            }
                        } else {
                            vm.backendErrorMessages.push('Ups... something went wrong. Please try again.')
                        }
                    })
                    .finally(() => {
                        setTimeout(() => {
                            vm.loading = false
                        }, 600)
                    })
            }
        },

        cancel() {
            this.dialog = false
            this.clearForm()

            EventBus.$emit('refresh_dt_maintenance_schedule_group', null)
        },

        clearForm() {
            this.item = {}
            this.formTitle = "Edit maintenance record"
            this.note = null
            this.servicemen = null
            this.device_name = null
            this.maintenance_timestamp = null
            this.last_maintenance = null
            this.last_maintenance_entrances = null

            this.business_premise_id = null
            this.business_premise_uuid = null
            this.organization_id = null
            this.maintenance_schedule_group_id = null
            this.maintenance_schedule_group_uuid = null

            this.loading = false
            this.disableSubmit = false
            this.cancelText = 'Cancel'

            this.clearBackendMessages()

            if (this.$refs.form) {
                this.$refs.form.resetValidation()
            }
        },

        clearBackendMessages() {
            this.backendValidationMessages = []
            this.backendMessages = []
            this.backendErrorMessages = []
        },

        setupData() {
            let lastMaintenanceText = null

            if(this.item.last_maintenance) {
                let lmTimestamp = this.item.last_maintenance.service_completed_at_formatted;
                
                lastMaintenanceText = this.item.last_maintenance.servicemen;

                if(lmTimestamp !== null && lmTimestamp !== "") {
                    //lastMaintenanceText = lastMaintenanceText + " (" + lmTimestamp + ") [ ID: " + this.item.last_maintenance.id + " ]"
                    lastMaintenanceText = lastMaintenanceText + " (" + lmTimestamp + ") [ TS: " + this.item.last_maintenance.service_completed_at_formatted + "(ID:)" + this.item.id+ " ]"
                }
            }

            this.maintenance_timestamp = this.item.service_completed_at_formatted || ''
            this.servicemen = this.item.servicemen_name || ''
            this.device_name = this.item.business_premise_name || ''
            this.note = this.item.note || null

            this.business_premise_id = this.item.business_premise_id
            this.business_premise_uuid = this.item.business_premise_uuid
            this.organization_id = this.item.organization_id
            this.maintenance_schedule_group_id = this.item.id
            this.maintenance_schedule_group_uuid = this.item.uuid
            this.formTitle = this.formTitle + " (ID: " + this.maintenance_schedule_group_id + ")"
        }
    },

    created() {
        let vm = this

        EventBus.$on('EDIT_MAINTENANCE_DIALOG', function(data) {
            vm.item = data
            vm.setupData()
            vm.dialog = true
        })
    },

    beforeDestroy() {
        this.item = {}
        EventBus.$off('EDIT_MAINTENANCE_DIALOG')
    }
}
</script>

<style scoped>
.v-card__title {
    background-color: #f5f5f5 !important;
}

#form--card--actions--desktop {
    padding: 10px 24px 10px !important;
}

#form--card--actions--mobile {
    padding: 20px 24px 20px !important;
}
</style>